<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-20 19:24:03
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-12-12 15:05:34
-->
<template>
	<div>
		<el-table
			v-bind="$attrs"
			:data="list"
			ref="table"
			:stripe="options.stripe"
			:border="options.border"
			:fit="options.fit"
			:highlight-current-row="options.highlightCurrentRow"
			:header-row-class-name="'table-header-row' + ` ${$attrs.bigger ? '' : 'fz-12'}`"
			row-class-name="table-row"
			:show-header="isShowHeader"
			:row-key="options.rowKey"
			@cell-mouse-enter="cellMouseEnterHandle"
			@cell-mouse-leave="cellMouseLeaveHandle"
			@sort-change="sortChange"
			@select-all="selectionAllChange"
			:max-height="maxHeight"
		>
			<el-table-column label="排序" v-if="draggable" width="60">
				<el-tooltip :open-delay="300" effect="dark" content="拖拽排序" placement="top">
					<img style="width: 8px; heigth: 12px" src="@/assets/public/drag-icon.png" alt="" srcset="" />
				</el-tooltip>
			</el-table-column>
			<el-table-column v-if="options.hasIndex" type="index" width="50"></el-table-column>
			<template v-for="(column, index) in sortColumns">
				<el-table-column
					:key="column.key + '_' + index"
					:width="column.width"
					:min-width="column.minWidth"
					:fixed="column.fixed"
					:render-header="column.renderHeader"
					:sortable="column.sortable"
					:prop="column.key"
					:resizable="column.resizable"
					:formatter="column.formatter"
					:show-overflow-tooltip="column.showOverflowTooltip"
					:align="column.align || 'left'"
					:label="column.label"
					:header-align="column.headerAlign"
					:sort-method="
						(a, b) => {
							return a[column.key] - b[column.key];
						}
					"
				>
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle">{{ column.label }}</span>
						<el-tooltip class="item" effect="dark" placement="top" :open-delay="300">
							<div slot="content">
								<p class="content pre" v-for="(item, index) in column.helpNum" :key="index">
									{{ column['helpDesc' + item] }}
								</p>
							</div>
							<i
								class="iconfont icon-a-help-circlebangzhu-mian ml-6 yx-color-text-placeholder"
								style="vertical-align: middle; font-weight: 400"
								v-if="column.helpNum"
							></i>
						</el-tooltip>
					</template>
					<template slot-scope="{ row }">
						<component
							:useByTable="true"
							:column="column"
							:row="column.transform ? column.transform(row) : row"
							:rowIsHover="hoverRowData === row"
							:tabName="tabName"
							:row-index="index"
							:is="column.type || defaultType"
							@change="changeValue"
						></component>
					</template>
				</el-table-column>
			</template>

			<template slot="empty" v-if="$slots.empty">
				<slot name="empty"></slot>
			</template>
		</el-table>
	</div>
</template>

<script>
import CellTypes from '@/components/tableCells/index';
import Sortable from 'sortablejs';

export default {
	components: {
		...CellTypes,
	},
	name: 'SortTable',
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		list: {
			type: Array,
			default: () => [],
		},
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		sortableProp: {
			type: Object,
			default: () => {
				return {};
			},
		},
		sortChange: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
		isShowHeader: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
		tabName: {
			type: String,
			default: () => {
				return '0';
			},
		},
		draggable: {
			type: Boolean,
			default: true,
		},
		maxHeight: {
			type: [String, Number],
			default: '100%',
		},
	},
	data() {
		return {
			defaultType: 'TextCell',
			MixinCell: 'MixinCell',
			hoverRowData: {},
			activeKey: '',
			sortColumns: [],
			sortedList: [],
		};
	},
	watch: {
		list: {
			deep: true,
			immediate: true,
			handler(val) {
				this.sortedList = val;
				this.$emit('sortTableChange', this.sortedList);
			},
		},
		columns: {
			deep: true,
			immediate: true,
			handler(val) {
				this.sortColumns = val;
			},
		},
		sortableProp() {
			this.$refs.table.clearSort();
		},
	},
	mounted() {
		if (this.draggable) {
			const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
			this.sortable = Sortable.create(el, {
				animation: 180,
				delay: 0,
				onEnd: ({ oldIndex, newIndex }) => {
					const tempList = this.sortedList.slice();
					const currRow = tempList.splice(oldIndex, 1)[0];
					tempList.splice(newIndex, 0, currRow);
					this.sortedList = tempList;
					this.$emit('sortTableChange', this.sortedList);
				},
			});
		}
	},
	methods: {
		sortCbHandle(key, isUp) {
			this.activeKey = key;
			this.$attrs.customSortChangeCb?.(key, isUp);
		},
		cellMouseEnterHandle(row, column, cell, event) {
			this.hoverRowData = row;
		},
		cellMouseLeaveHandle(row, column, cell, event) {
			this.hoverRowData = {};
		},
		changeValue(value) {
			this.$emit('change', value);
		},
		toggleSelection(rows, e) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.table.toggleRowSelection(row, e);
				});
			}
		},
		selectionAllChange() {
			this.$emit('selectionAllChange');
		},
		doLayout() {
			this.$refs.table.doLayout();
		},
		getTableRef() {
			return this.$refs.table;
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	width: fit-content;
	max-width: 250px;
}

/deep/ .el-table__empty-text {
	line-height: 30px;
}
</style>
<style lang="less">
.el-checkbox__label {
	padding-left: 16px;
}
</style>
